import styled from 'styled-components';
import { rem } from 'polished';
import { VehiclePriceDetailsBlockStyled } from '../VehiclePriceDetailsBlockStyled';
export const VehiclePriceDetailsBlockStyledOV = styled(VehiclePriceDetailsBlockStyled)`
    .row {
        .rowTitle {
            font-size: ${rem('14px')};
        }

        .info,
        .infoOptions {
            font-size: ${rem('14px')};
            line-height: 1.43;
        }
    }
`;
